<template>
  <v-container fluid grid-list-xs>
    <v-card class="">
      <v-card-title class="primary">
        <v-icon class="icon-space white--text" left>assignment</v-icon>
        <span class="ml-4 headline white--text">PROJECT MANAGEMENT OVERVIEW</span><span class="beta-text ml-3">beta</span>
        <v-spacer></v-spacer>
        <v-text-field
          dark
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
          :headers="headersProjects"
          :items="projectsManagementOverview"
          :search="search"
          :rows-per-page-items='[8, 15, 25, { text: "All", value: -1 }]'
          light
        >
        <template slot="items" slot-scope="props">
          <tr
            class=""
            @click="setSelectedProject(props.item.id); props.expanded = !props.expanded"
          >
            <td>
              <v-icon
                large
                v-if='props.item.updateStatus == "3 - green"'
                color="light-green darken-2"
              >star
              </v-icon>
              <v-icon
                large
                v-else-if='props.item.updateStatus == "2 - yellow"'
                color="amber darken-1"
              >info
              </v-icon>
              <v-icon
                large
                v-else-if='props.item.updateStatus == "1 - red"'
                color="red darken-2"
              >warning
              </v-icon>
              <v-icon
                large
                v-else
                color="secondary darken-3"
              >help
              </v-icon>
              </td>
              <td>{{ props.item.cName }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.leadName }}</td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card flat>
          <project></project>
          </v-card>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {
  database,
  projectsRef,
  projectManagementOverviewViewRef,
  projectManagementDetailsViewRef
} from "@/vue-service-database";
import Project from "./Project.vue";
import store from "@/store/";

export default {
  components: {
    project: Project
  },
  firebase: {
    projects: projectManagementOverviewViewRef
  },
  computed: {
    projectsTableExport() {
      let exportObject = {};
      for (let i; i < this.projects.length; i++) {
        console.log("this.projects:", this.projects[i]);
        exportObject[i] = this.projects[i];
      }
      return exportObject;
    },
    projectsManagementOverview() {
      return Array.from(this.$store.getters.projectsManagementOverview);
    },
    selectedProjectKey() {
      return this.$store.getters.selectedProjectKey;
    },
    projectsManagementDetails() {
      return this.$store.getters.projectsManagementDetails;
    },
    projectStatusIsGreen() {
      let project = this.$store.getters.project;
      if (project.updateStatus == "3 - green") {
        return true;
      }
      return false;
    },
    projectStatusIsYellow() {
      let project = this.$store.getters.project;
      if (project.updateStatus == "2 - yellow") {
        return true;
      }
      return false;
    },
    projectStatusIsRed() {
      let project = this.$store.getters.project;
      if (project.updateStatus == "1 - red") {
        return true;
      }
      return false;
    }
  },
  methods: {
    setSelectedProject(key) {
      /*
        / key is returned from v-data-table <tr> @click=" ... "
        / key is dispatched to store.setSelecdtedProjectKey
        / Let's use this project to find a project in projectsRef
        */
      console.log("setSelectedProject KEY", key);
      projectManagementDetailsViewRef.child(key).once("value", snapshot => {
        let project = snapshot.val();
        console.log("project", project);
        this.$store.dispatch("SET_SELECTED_PROJECT_KEY", key);
        this.$store.dispatch("SET_PROJECT", project);
        return project;
      });
    }
  },
  data() {
    return {
      tmp: "",
      search: "",
      pagination: {},
      headersProjects: [
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "updateStatus"
        },
        {
          text: "Client",
          align: "left",
          sortable: true,
          value: "cName"
        },
        {
          text: "Project",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Lead",
          align: "left",
          sortable: true,
          value: "leadName"
        }
      ],
      tempData: [
        {
          updatedOn: "01/01/2018",
          updateDetails:
            "Here are some details regarding the projects status, a Yellow warning",
          status: "Yellow"
        },
        {
          updatedOn: "01/04/2018",
          updateDetails:
            "The latest update - Fake details regarding the projects status. Fake updates ready for Prod v1.5.2.",
          status: "Green"
        }
      ]
    };
  },
  created: function() {
    /*
        / If the selectedProjectKey is null, then
        / Update Store selectedProjectKey to first project in PMO
        */
    if (!this.$store.getters.selectedProjectKey) {
      let self = this;
      let key = this.$store.getters.projectsManagementOverview[0].id;
      this.$store.dispatch("SET_SELECTED_PROJECT_KEY", key);
      console.log(
        "this.$store.getters.projectsManagementDetails[0]",
        this.$store.getters.projectsManagementDetails[0]
      );
      self.setSelectedProject(key);
    }
  }
};
</script>

<style scoped>
/* style the userImage to fit in nav */
.toolbar-title-img {
  max-width: 35px;
}
.beta-text {
  /* font-size: .75em; */
  color: lightcoral;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/Projects.vue